import {jsonMember, jsonObject} from "typedjson";
import {DxRequestOptions} from "./dx-request-options";
import {HttpHeaders} from "@angular/common/http";
import {DxHttpErrorInterceptor} from "../../interceptors/dx-http-error-interceptor";
import {DxObjectMapper} from "../../services/dx-object-mapper.service";
const cloneDeep = require('lodash.clonedeep');

/***
 *  дополнительная структура, используемая, совместно с {@link DxHttpErrorInterceptor.CLIENT_HANDLER_EXTRA_HEADER} как value,
 *  для обработки HttpErrorResponse
 */
@jsonObject()
export class ClientHandlerExtra {

  /**
   * на бэке есть соответствующая константа, которая обрабатывается фильтром, выполняющим проброс значения обратно
   */
  static CLIENT_HANDLER_EXTRA_HEADER = "Client-Handler-Extra";

  /**
   *  игнорировать глобальную обработку и пропустить ошибку,
   *  можно применить в особо трудных случаях
   */
  @jsonMember({constructor: Boolean, isRequired: false, emitDefaultValue: false})
  ignoreGlobal: boolean;

  /**
   *  игнорировать и пропустить ошибку 400 дальше
   */
  @jsonMember({constructor: Boolean, isRequired: false, emitDefaultValue: false})
  ignore400: boolean;

  /**
   *  глобально обработать и пропустить ошибку 500 дальше
   */
  @jsonMember({constructor: Boolean, isRequired: false, emitDefaultValue: false})
  passBelow500: boolean;


  constructor(fields?: Partial<ClientHandlerExtra>) {
    if (fields)
      Object.assign(this, fields);
  }

  public applyToOptions(serviceOptions: DxRequestOptions): DxRequestOptions {
    const options: DxRequestOptions = cloneDeep(serviceOptions);
    options.headers = (options.headers as HttpHeaders).set(ClientHandlerExtra.CLIENT_HANDLER_EXTRA_HEADER, DxObjectMapper.serialize<ClientHandlerExtra>(this, ClientHandlerExtra));
    return options;
  }
}
